import { createReducer } from "@reduxjs/toolkit";
import { typePagination } from "../system/constants";
import { typeGetEncashResponse } from "./dStoresSaga";
import {logoutAC, resetReducers} from "../system/systemActionCreators";
import {
  dStoresSetDataAC,
  dStoresEditItemAC,
  dStoresSetFiltersAC,
  dStoresClearFiltersAC,
  dStoresSetPageNumberAC,
  dStoresSetPaginationAC,
  dStoresSetDetailItemAC,
  dStoresSetItemsForPageAC,
} from "./dStoresActionCreators";

export type typeEditStore = {
  id: string;
  name?: string;
  email?: string;
  manager?: string;
  phoneNumber?: string;
  description?: string;
  managerPhoneNumber?: string;
};

export type IdStoresState = {
  filters: typeStoreFilters;
  pagination: typePagination;
  data: IdStoresStateDataItem[];
  detailItem: IdStoresStateDataItem | undefined;
};

export type typeStoreFilters = {
  name: string | null;
  deleted?: boolean | null;
  full?: boolean;
};

export type IdStoresStateDataItem = {
  id: string;
  name: string;
  email?: string;
  address?: string;
  manager?: string;
  industry?: {
    id: string;
    nameMap: {
      uz: string;
      en: string;
      ru: string;
    };
    parentId: string | null;
    externalId: string | null;
    externalSystemCode: string | null;
  };
  deleted: boolean;
  checked?: boolean;
  phoneNumber: string;
  description: string;
  managerPhoneNumber?: string;
  cash_balance: number | null;
  terminals: typeGetEncashResponse | [];
};

export const cleanFilterObject: typeStoreFilters = {
  name: null,
  deleted: null,
};

export const initialState: IdStoresState = {
  pagination: {
    pageNumber: 0,
    itemsPerPage: 14,
  },
  data: [],
  detailItem: undefined,
  filters: cleanFilterObject,
};

export const DStoresReducer = createReducer(initialState, (builder) => {
  builder

    // Reducer of set data
    .addCase(dStoresSetDataAC, (state, action) => {
      state.data = action.payload.dataList;
    })

    // Reducer of set detail item
    .addCase(dStoresSetDetailItemAC, (state, action) => {
      if (action.payload) {
        state.detailItem = state.data.find(
          (item) => item.id === action.payload,
        );
      } else {
        state.detailItem = undefined;
      }
    })

    // Reducer of set item in data
    .addCase(dStoresEditItemAC, (state, action) => {
      state.data = state.data.map((item) => {
        if (item.id === action.payload.id) {
          return action.payload;
        } else {
          return item;
        }
      });
    })

    // Reducer of clear filtersForm
    .addCase(dStoresClearFiltersAC, (state) => {
      state.filters = {
        name: null,
        deleted: null,
      };
    })
    .addCase(dStoresSetPaginationAC, (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload.pagination };
    })
    .addCase(dStoresSetPageNumberAC, (state, action) => {
      state.pagination.pageNumber = action.payload.pageNumber;
    })
    .addCase(dStoresSetItemsForPageAC, (state, action) => {
      state.pagination = {
        ...state.pagination,
        pageNumber: 0,
        itemsPerPage: action.payload.itemsForPage,
      };
    })

    // Reducer of set filtersForm
    .addCase(dStoresSetFiltersAC, (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
      state.pagination.pageNumber = 0;
    })
    // Reducer of clear state
    .addCase(logoutAC, (state) => {
      state.data = initialState.data;
      state.detailItem = initialState.detailItem;
      state.filters = initialState.filters;
      state.pagination = initialState.pagination;
    })

    .addCase(resetReducers, (state, action) => {
        if (action.payload !== "stores") {
          state.data = initialState.data;
          state.detailItem = initialState.detailItem;
          state.filters = initialState.filters;
          state.pagination = initialState.pagination;
        }
    });
});
